import { Button, ColumnTable } from '@octano/global-ui';
import { useMemo, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import dayjs from 'dayjs';
import BadgeState from '../../../../../components/badgeStatus/BadgeState';

import { StudentsRemovalRequestItemResolved } from '../../types';
import { useTexts } from './useTexts';
import { PathsLayouts } from '../../../../../config/routes';

export function useColumns(): ColumnTable<StudentsRemovalRequestItemResolved>[] {
  const texts = useTexts().table;
  const history = useHistory();

  const goToView = useCallback(
    (id: number) => {
      history.push(
        `${PathsLayouts.studentsRemovalRequestsManage}/${id}/detail`,
      );
    },
    [history],
  );

  return useMemo(
    () => [
      {
        columnName: 'studentName',
        headerText: texts.headers.name,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        cellFormat: ({ row }) => (
          <>
            {row.student.accountLastNames}, {row.student.accountNames}
          </>
        ),
      },
      {
        columnName: 'studentId',
        headerText: texts.headers.id,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        cellFormat: ({ row }) => (
          <>
            {row.student.identificationTypeName}{' '}
            {row.student.identificationValueFormatted}
          </>
        ),
      },
      {
        columnName: 'studyPlan',
        headerText: texts.headers.studyPlan,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        cellFormat: ({ row }) => <>{row.studyPlanVersion.name}</>,
      },
      {
        columnName: 'askedBy',
        headerText: texts.headers.askedBy,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        cellFormat: ({ row }) => (
          <>
            <div>
              {row.removalRequest.requestedBy.accountLastNames},{' '}
              {row.removalRequest.requestedBy.accountNames}
            </div>
            <div>
              {dayjs(row.removalRequest.requestedAt).format('DD/MM/YYYY')}
            </div>
          </>
        ),
      },

      {
        columnName: 'status',
        headerText: texts.headers.status,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        cellFormat: ({ row }) => (
          <BadgeState
            status={row.removalRequest.state}
            genderContext="female"
          />
        ),
      },
      {
        columnName: 'resolvedBy',
        headerText: texts.headers.resolvedBy,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        cellFormat: ({ row }) => (
          <>
            <div>
              {row.removalRequest.response.resolvedBy.accountLastNames},{' '}
              {row.removalRequest.response.resolvedBy.accountNames}
            </div>
            <div>
              {dayjs(row.removalRequest.response.resolvedAt).format(
                'DD/MM/YYYY',
              )}
            </div>
          </>
        ),
      },
      {
        columnName: 'action',
        headerText: texts.headers.action,
        tdClassName: 'text-center text-primary',
        thClassName: 'text-center',
        width: 120,
        cellFormat: ({ row }) => (
          <Button
            type="button"
            text={texts.viewDetailButton}
            size="sm"
            color="primary"
            onClick={() => goToView(row.removalRequest.id)}
          />
        ),
      },
    ],
    [texts, goToView],
  );
}
